import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNomePesquisa = (): TabelaColuna => ({
  Chave: 'nomePesquisa',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome Pesquisa</div>
})
